import React from "react";

export const HomeIcon: React.FC<{ size?: string }> = ({ size = "20" }) => {
  return (
    <svg
      style={{ marginTop: "-4px" }}
      width={size}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="42" height="42" fill="white" />
      <path
        d="M6 17.5L21 5L36 17.5V37.5H23V28C23 26.8954 22.1046 26 21 26V26C19.8954 26 19 26.8954 19 28V37.5H6V17.5Z"
        fill="#3F90B5"
      />
    </svg>
  );
};
